import { FC, ReactNode } from "react";
import { useRecoilValue } from "recoil";
import { isShowMarkerPopupCardState } from "../stores";
import { IfBlock } from "../components/IfBlock";
export const IfShowMarker: FC<{
    children: ReactNode
}> = ({ children }) => {
    const visible = useRecoilValue(isShowMarkerPopupCardState);
    return <IfBlock visible={visible}>{children}</IfBlock>
};
